import React from "react";

const PricingStructure = () => {
    const packages = [
        {
            title: "On-Demand",
            credits: "1 Credit",
            price: "$250",
            description: "Ideal for occasional hiring.",
        },
        {
            title: "Small Business",
            credits: "5 Credits",
            price: "$1000",
            description: "Save $250 when you purchase in bulk.",
        },
        {
            title: "Growing Enterprise",
            credits: "10 Credits",
            price: "$1750",
            description: "Enjoy a savings of $750 for large-scale hiring.",
        },
    ];

    return (
        <section className="bg-bluegray p-8 rounded-lg shadow-lg max-w-5xl mx-auto">
            <div className="text-center mb-8">
                <h1 className="text-orange text-3xl font-bold mb-2">Your First Job Is Free</h1>
                <p className="text-lightblue text-lg font-bold mb-4">
                    Candidates never pay — job seekers always access Career Mission at no cost.
                </p>
                <h2 className="text-orange text-3xl mb-2">Our Pricing Structure</h2>
                <p className="text-lightgray text-lg">
                    Flexible pricing options designed to suit your recruitment needs.
                </p>
                <p className="mt-4 text-lightblue text-xl font-semibold">
                    New users start with 1 free credit!
                </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                {packages.map((pkg, index) => (
                    <div
                        key={index}
                        className="bg-deepblue rounded-lg shadow p-6 flex flex-col items-center transition transform hover:-translate-y-1 hover:scale-105 hover:shadow-lg"
                    >
                        <h3 className="text-orange text-2xl font-semibold mb-4">
                            {pkg.title}
                        </h3>
                        <p className="text-lightgray text-xl font-semibold mb-2">
                            {pkg.credits}
                        </p>
                        <p className="text-lightgray text-lg mb-4">{pkg.price}</p>
                        <p className="text-lightgray text-center">{pkg.description}</p>
                    </div>
                ))}
            </div>
            <div className="text-center">
                <p className="text-lightgray text-lg mb-2">
                    Credits are used to unlock the sorted list of candidates who match your super star target.
                </p>
                <p className="text-lightgray text-lg mb-2">
                    Don't get stuck reading thousands of resumes, and don't lose great candidates to basic keyword filters.
                </p>
                <p className="text-lightgray text-lg">
                    For any questions or custom pricing needs, please send us a message at{" "}
                    <a
                        href="mailto:contact@careermission.ai"
                        className="text-lightblue hover:underline font-medium"
                    >
                        contact@careermission.ai
                    </a>
                </p>
            </div>
        </section>
    );
};

export default PricingStructure;
